@import (reference) '../../../../../constants/spacing.module.less';

.errorBanner {
  margin-bottom: @space-16;
}

.description {
  margin-bottom: @space-16;
}

.name {
  margin-bottom: @space-8;
}

.helperText {
  color: var(--grey-500);
}
